module.exports = __webpack_public_path__ + "img/video1.840357f2.png";